<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 p-0 m-b-6'">
    <div>
        <div class="p-10 headercmp" fxlayout="row" fxlayoutalign="space-between center">
            <div class="pr-16">
                <div class="h3">
                    <mat-icon *ngIf="employeeStoreService.employee?.importacionId === -1" class="lock-icon">lock
                    </mat-icon>
                    {{employeeStoreService.employee?.apellidos }} {{employeeStoreService.employee? ', ':''}}
                    {{employeeStoreService.employee?.nombre }}
                </div>
                <div class="breadcrumbtxtcolor" fxlayout="row" fxlayoutalign="start center">
                    <div id="breadcrumb-position" *ngFor="let nevil of employeeService.nevil; let i = index">

                        <span>{{nevil.nivel1}}</span>
                        <mat-icon *ngIf="nevil.nivel2 != null" class="s-16 mat-icon material-icons mat-icon-no-color"
                            role="img" aria-hidden="true">chevron_right
                        </mat-icon>
                        <span>{{nevil.nivel2}}</span>
                        <mat-icon *ngIf="nevil.nivel3 != null" class="s-16 mat-icon material-icons mat-icon-no-color"
                            role="img" aria-hidden="true">chevron_right
                        </mat-icon>
                        <span>{{nevil.nivel3}}</span>
                        <mat-icon *ngIf="nevil.nivel4 != null" class="s-16 mat-icon material-icons mat-icon-no-color"
                            role="img" aria-hidden="true">chevron_right
                        </mat-icon>
                        <span>{{nevil.nivel4}}</span>
                        <mat-icon *ngIf="nevil.nivel5 != null" class="s-16 mat-icon material-icons mat-icon-no-color"
                            role="img" aria-hidden="true">chevron_right
                        </mat-icon>
                        <span>{{nevil.nivel5}}</span>
                    </div>
                </div>
            </div>
            <div class="pl-16 header-client-card" fxlayout="row wrap">
                <div class="phone-number-area w-220" fxlayout="row wrap" fxlayoutalign="space-between center">
                    
                        <div class="pr-16" *ngIf="employeeStoreService.employee?.telefono1 && employeeStoreService.employee.telCancelado!='S'">
                            <mat-icon class="font-size-14">call</mat-icon>
                            <span> {{ employeeStoreService.employee?.telefono1 }}</span>
                        </div>
                        <div class="pr-16" *ngIf="employeeStoreService.employee?.telefono2 && employeeStoreService.employee.telCancelado!='S'">
                            <mat-icon class="font-size-14">call</mat-icon>
                            <span> {{ employeeStoreService.employee?.telefono2 }}</span>
                        </div>
                        <div class="pr-16" *ngIf="employeeStoreService.employee?.movil && employeeStoreService.employee.telCancelado!='S'">
                            <mat-icon class="font-size-14">call</mat-icon>
                            <span> {{ employeeStoreService.employee?.movil }}</span>
                        </div>
                        <div class="pr-16" *ngIf="employeeStoreService.employee?.telefono4 && employeeStoreService.employee.telCancelado!='S'">
                            <mat-icon class="font-size-14">call</mat-icon>
                            <span> {{ employeeStoreService.employee?.telefono4 }} </span>
                        </div>

                    <div class="btn-group">
                        <div class="pr-16 m-b-10 m-l-5">
                            <button mat-raised-button class="mat-accent"
                                *ngIf="employeeService.HasWarningCreationPermit && !employeeService.EmployeeWarningText"
                                (click)="CreateWarningMessage()">Crear Aviso</button>

                            <!-- Commented Until Development is Confirmed -->
                            <button mat-raised-button class="mat-accent" (click)="OpenLeaveReportPopup()">Informe</button>
                            <button *ngIf="permissions.includes('629')" mat-raised-button class="mat-accent" (click)="PrintCartaLopd()">Carta LOPD</button>

                            <button *ngIf="permissions.includes('307')" mat-raised-button class="mat-accent"
                                (click)="OpenCostReportPopup()">Coste</button>
                        </div>
                        <div *ngIf="employeeService.HasWarningCreationPermit && !employeeService.EmployeeWarningText"
                            class="pr-16 m-b-10 m-l-5">
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>